import { Link, useParams } from 'react-router-dom';
import { posts } from '@/content/posts';

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <section className="py-12">
        <p className="label mb-4">404</p>
        <h1 className="font-display text-3xl font-medium mb-4">
          That entry doesn't exist.
        </h1>
        <Link to="/blog">← Back to the journal</Link>
      </section>
    );
  }

  return (
    <article className="py-4 md:py-12">
      <Link to="/blog" className="label no-underline hover:text-accent">
        ← Blog
      </Link>

      <header className="mt-6 mb-10 max-w-prose">
        <div className="label mb-3">
          <time dateTime={post.date}>{formatDate(post.date)}</time>
          {post.tags.length > 0 && (
            <>
              <span className="mx-2 text-rule">·</span>
              <span>{post.tags.join(' / ')}</span>
            </>
          )}
        </div>
        <h1
          className="font-display font-medium leading-[1.05] tracking-[-0.01em]"
          style={{ fontSize: 'var(--size-h1)' }}
        >
          {post.title}
        </h1>
        <p className="mt-4 text-ink-muted text-lg leading-relaxed">
          {post.summary}
        </p>
      </header>

      <div className="max-w-prose text-lg leading-relaxed whitespace-pre-wrap">
        {post.body}
      </div>
    </article>
  );
}
